export default "__VITE_ASSET__BGnBCsiz__"